module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-14-45b11792d2e911b1699eec34f40a8f6f.svg";